import React from "react";

import ClockIcon from "../../atoms/icons/Clock";
import BookmarkIcon from "../../atoms/icons/Bookmark";
import SharekIcon from "../../atoms/icons/Share";
import Button from "../../atoms/button/button";

import { JobDetails } from "../../../interfaces/JobDetails";

// Styles //
import "./JobName.scss";

const MAIN_CLASS = "m-job-name";

const separateDateAndYear = (fechaStr: string) => {
    const regex = /(\d{1,2} de \w+) (\d{4})/i;
    const match = fechaStr?.match(regex);

    if (!match) return null;

    const date = match[1];
    const year = match[2];

    return { date, year };
};

interface JobNameProps {
    jobDetails: JobDetails;
    onClickPostulate?: () => void;
    onClickShare?: () => void;
}

const JobName = ({
    jobDetails,
    onClickPostulate,
    onClickShare,
}: JobNameProps) => {
    const separatedDate = separateDateAndYear(jobDetails.date);
    return (
        <div className={MAIN_CLASS}>
            <div className={`${MAIN_CLASS}__info-container`}>
                <h1 className={`${MAIN_CLASS}__title`}>{jobDetails.title}</h1>
                <p className={`${MAIN_CLASS}__code`}>
                    Código {jobDetails.referenceNumber}
                </p>
                <div className={`${MAIN_CLASS}__info`}>
                    <div className={`${MAIN_CLASS}__publish`}>
                        <ClockIcon />
                        <span>
                            Publicado
                            {separatedDate
                                ? `
                              ${separatedDate.date} | ${separatedDate.year}
                              `
                                : jobDetails.date}
                        </span>
                    </div>
                    <div className={`${MAIN_CLASS}__share`}>
                        {/* <button
                            title="Agregar a favoritos"
                            className={`${MAIN_CLASS}__share__button`}
                        >
                            <BookmarkIcon />
                        </button> */}
                        <button
                            onClick={onClickShare}
                            title="Compartir"
                            className={`${MAIN_CLASS}__share__button`}
                        >
                            <SharekIcon />
                        </button>
                    </div>
                </div>
            </div>

            <div className={`${MAIN_CLASS}__button-container`}>
                <Button
                    type={"button"}
                    classname={
                        "a-button__magenta_aceleradora big center btn-apply gtmVacanteClickButtonPostularme"
                    }
                    text={"Postularme"}
                    isDisabled={undefined}
                    onClickAction={onClickPostulate}
                />
            </div>
        </div>
    );
};

export default JobName;
